module.exports = __webpack_public_path__ + "static/img/category_30.a6d6295.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/category_30.jpg
// module id = 7BWC
// module chunks = 0